/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetEntryExport } from './TimesheetEntryExport';
import {
    TimesheetEntryExportFromJSON,
    TimesheetEntryExportFromJSONTyped,
    TimesheetEntryExportToJSON,
    TimesheetEntryExportToJSONTyped,
} from './TimesheetEntryExport';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListTimesheetEntryExportsResponse
 */
export interface ListTimesheetEntryExportsResponse {
    /**
     * 
     * @type {Array<TimesheetEntryExport>}
     * @memberof ListTimesheetEntryExportsResponse
     */
    data: Array<TimesheetEntryExport>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListTimesheetEntryExportsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListTimesheetEntryExportsResponse interface.
 */
export function instanceOfListTimesheetEntryExportsResponse(value: object): value is ListTimesheetEntryExportsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListTimesheetEntryExportsResponseFromJSON(json: any): ListTimesheetEntryExportsResponse {
    return ListTimesheetEntryExportsResponseFromJSONTyped(json, false);
}

export function ListTimesheetEntryExportsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTimesheetEntryExportsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TimesheetEntryExportFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListTimesheetEntryExportsResponseToJSON(json: any): ListTimesheetEntryExportsResponse {
      return ListTimesheetEntryExportsResponseToJSONTyped(json, false);
  }

  export function ListTimesheetEntryExportsResponseToJSONTyped(value?: ListTimesheetEntryExportsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TimesheetEntryExportToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

